<template>
    <v-row align="center" justify="center">
        <v-dialog v-model="$root.loading.mostrar" persistent fullscreen >
            <v-container class="fill-height background-container" fluid>
                <v-row align="center" justify="center">
                    <v-progress-circular indeterminate :size="100" :width="7" color="primary">{{ texto }}</v-progress-circular>
                </v-row>
            </v-container>
        </v-dialog>
    </v-row>
</template>

<script>
export default {
    data(){
        return{
            texto: 'Cargando',
            loading: {
                mostrar: false,
            }
        }
    },
}
</script>
<style type="text/css">
    .background-container{
        background-color: rgba(176,79,79,0.3);
    }
</style>